<script setup lang="ts">
    import useShow from '@/shared/composables/useShow';
    import { useShippingStore } from '@/stores/shippingStore';
    import { isPackageEditable } from './shippingPackageMetadata';

    const store = useShippingStore();
    const { showError } = useShow();

    async function onEdit(): Promise<void> {
        try {
            await store.startEditWizard(store.selectedPackage!);
        } catch (err) {
            showError(err);
        }
    }
</script>

<template>
    <b-button
        v-if="isPackageEditable(store.selectedPackage)"
        icon-left="pencil"
        :loading="store.startingEdit"
        @click="onEdit">
        Edit
    </b-button>
</template>
